import React, { useCallback } from "react";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";

type SwitchProps = {
  disabled: boolean;
  label: string;
  checked: boolean;
  onCheckedChange: (newValue: boolean) => void;
  icon: (prefix?: string) => React.SVGProps<SVGElement>[];
};

function Switch({
  disabled,
  label,
  checked,
  onCheckedChange,
  icon,
}: SwitchProps) {
  const handleChange = useCallback(() => {
    onCheckedChange(!checked);
  }, [onCheckedChange, checked]);

  return (
    <FixaListViewItem
      title={label}
      inset
      leadingIcon={icon}
      control="switch"
      onChange={handleChange}
      controlProps={{ checked, value: "" }}
      disabled={disabled}
    />
  );
}

export default Switch;
